LiveForm.setOptions({
	messageErrorClass: 'error',
	showMessageClassOnParent: 'form-pair',
	controlErrorClass: 'with-error',
	wait: 500
});
